export default function initPermissionsList(permissions: Array<string>): Set<string> {
    return new Set([...permissions])
}